export default "__VITE_ASSET__V9HfJWnW__"